import { useRef, useCallback } from 'react';
/**
 * @param rawCallback
 */
export default function useCallbackRef(rawCallback) {
    const cleanupRef = useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(((node) => {
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (node) {
            cleanupRef.current = rawCallback(node);
        }
    }), [rawCallback]);
}
//# sourceMappingURL=useCallbackRef.js.map